import type { FC, ReactNode } from 'react'
import type { DocumentSection } from '@/components/generals/document-page'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { DocumentPage } from '@/components/generals/document-page'

const sections: DocumentSection[] = [
    {
        heading: 'Cards we accept',
        paragraphs: [
            'Visa, Mastercard, American Express, Discover, JCB and Diners Club, issued in any country. Debit cards carrying one of those networks work the same way.'
        ]
    },
    {
        heading: 'Wallets and instalments',
        paragraphs: [
            'Apple Pay, Google Pay, Shop Pay and PayPal are available at checkout on supported devices. Where local rules allow it, Klarna and Afterpay let you split payment across instalments at no extra cost.'
        ]
    },
    {
        heading: 'Currency',
        paragraphs: [
            'All prices are charged in US dollars. If your card is issued in another currency, your bank sets the conversion rate and may add its own fee, which we do not receive any part of.'
        ]
    },
    {
        heading: 'When you are charged',
        paragraphs: [
            'Your card is authorised at checkout and captured when the order ships. If an item cannot ship, the authorisation is released and nothing is taken.'
        ]
    },
    {
        heading: 'Security',
        paragraphs: [
            'Payments are handled by a PCI-DSS Level 1 certified processor. Card numbers are tokenised and never touch our servers, so there is nothing sensitive for us to store.',
            'Where your bank requires it, 3-D Secure adds a verification step during checkout.'
        ]
    },
    {
        heading: 'Duties and taxes',
        paragraphs: [
            'Sales tax is calculated at checkout where applicable. International orders may attract import duties on arrival, which are set by your country and payable by the recipient.'
        ]
    },
    {
        heading: 'Refunds',
        paragraphs: [
            'Refunds are returned to the original payment method within 3-5 business days of us receiving your return. Depending on your bank it can take a few more days to appear on your statement.'
        ]
    }
]

const PaymentMethods: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo
                title='Payment methods'
                description='Every card and wallet Nuvéa accepts, how your payment details are handled, and what happens at checkout.'
            />

            <DocumentPage
                titleLines={['Payment', 'Methods']}
                standfirst='Everything we accept at checkout, how your details are handled, and when your card is actually charged.'
                updatedOn='January 2026'
                sections={sections}
            />
        </Layout>
    )
}

export default PaymentMethods
